import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Text, Anchor } from '@sso/shared/core';
import { boxed } from '@sso/shared/hocs';

type TermsLinkProps = {
    children?: ReactNode;
    className?: string;
};

const StyledAnchor = styled(Anchor)`
    white-space: nowrap;
`;

function TermsLink({ children = 'You agree to the', className }: TermsLinkProps) {
    return (
        <Text color="neutral.subtitle" size="textSm" as="p" center className={className}>
            {children}{' '}
            <StyledAnchor href={`${window._sso_env_.PRODUCT_HOST}/legal`} target="_blank">
                Terms of Use
            </StyledAnchor>{' '}
            and{' '}
            <StyledAnchor href={`${window._sso_env_.PRODUCT_HOST}/privacy-policy`} target="_blank">
                Privacy Policy
            </StyledAnchor>
            .
        </Text>
    );
}

export default boxed(TermsLink);
